import { getSelectedPeriod } from "../../../../services/GroupContext";
import { addDataToExcel, addYesOrNoCIRCalcs } from "../utils/helpers";
import {
  disallowed_variables,
  fixed_ratio_variables,
  group_ratio_variables,
} from "../utils/metrics";

export const getCirCalculationsSection = (excelData) => {
  const selectedPeriodOfAccount = getSelectedPeriod();

  const group_ratio_election_check = (value) => {
    return selectedPeriodOfAccount.group_ratio_election
      ? value
      : [...value?.slice(0, -1), "N/A"];
  };

  addDataToExcel(selectedPeriodOfAccount, excelData, fixed_ratio_variables);
  addDataToExcel(selectedPeriodOfAccount, excelData, group_ratio_variables);
  addYesOrNoCIRCalcs(selectedPeriodOfAccount, excelData, disallowed_variables);

  return [
    ["Fixed Ratio Computation"],
    ["", "", "GBP"],
    excelData.aggregate_ebitda,
    excelData.fixed_ratio,
    [],
    excelData.angie,
    excelData.excess_debt,
    excelData.fixed_debt,
    [],
    excelData.basic_interest,
    excelData.antii,
    excelData.interest_allowance,
    [],
    [],
    ["Group Ratio Computation"],
    ["", "", "GBP"],
    group_ratio_election_check(excelData.qngie),
    group_ratio_election_check(excelData.group_ebitda),
    group_ratio_election_check(excelData.group_ratio),
    [],
    group_ratio_election_check(excelData.aggregate_ebitda2),
    group_ratio_election_check(excelData.group_ratio_ebitda),
    [],
    group_ratio_election_check(excelData.qngie),
    group_ratio_election_check(excelData.excess_debt2),
    group_ratio_election_check(excelData.group_debt_cap),
    [],
    group_ratio_election_check(excelData.group_basic_interest),
    group_ratio_election_check(excelData.antii),
    group_ratio_election_check(excelData.group_interest_allowance),
    [],
    [],
    ["Computation of Disallowance/reactivation"],
    [],
    [],
    excelData.group_ratio_election,
    ["", "", "GBP"],
    excelData.computation_int_allowance,
    excelData.unused_allowance,
    [],
    excelData.de_minimis,
    [],
    excelData.interest_capacity,
    [],
    excelData.aggregate_interest_expense,
    [],
    excelData.disallowed_amount,
    [],
    excelData.available_reactivation,
    [],
  ];
};
